// income type
export enum INCOME_TYPE {
  RENTAL_INCOME = 'rentalIncome',
  SINGLE_PARENTING = 'singleParenting',
  CHILD_SUPPORT = 'childSupport',
  INVESTMENT_INCOME = 'investmentIncome',
  CENTRELINK_FAMILY_BENEFITS = 'centrelinkFamilyBenefits',
  CENTRELINK_CARERS_PAYMENTS = 'centrelinkCarersPayments',
  CENTRELINK_DISABILITY_PAYMENTS = 'centrelinkDisabilityPayments',
  CENTRELINK_PENSION = 'centrelinkPension',
  CENTRELINK_NEWSTART = 'centrelinkNewstart',
  VETERAN_AFFAIRS = 'veteranAffairs',
  CENTRELINK_OTHER = 'centrelinkOther',
  AUSTUDY = 'austudy',
  OTHER = 'other',
  ADDITIONAL_JOB = 'additionalJob',
  COMMISSIONS_BONUSES = 'commissionsAndBonuses',
  WORK_AND_INCOME_BENEFITS = 'workAndIncomeBenefits',
  WORKING_FOR_FAMILIES = 'workingForFamilies',
  ACC = 'acc',
  STUDYLINK = 'studylink',
  OTHER_IRD_BENEFIT = 'otherIRDBenefit',
  CHILD_SUPPORT_NZ = 'childSupportNZ',
}
export const incomeTypeOptions = Object.values(INCOME_TYPE)

export type IncomeType = (typeof incomeTypeOptions)[number]

// Default AU other income type map
export const incomeTypeMap = {
  [INCOME_TYPE.RENTAL_INCOME]: 'Rental Income',
  [INCOME_TYPE.SINGLE_PARENTING]: 'Single Parenting',
  [INCOME_TYPE.CHILD_SUPPORT]: 'Child Support (CSA)',
  [INCOME_TYPE.INVESTMENT_INCOME]: 'Investment Income (e.g., shares)',
  [INCOME_TYPE.CENTRELINK_FAMILY_BENEFITS]: 'Centrelink Family Benefits',
  [INCOME_TYPE.CENTRELINK_CARERS_PAYMENTS]: 'Centrelink Carers Payments',
  [INCOME_TYPE.CENTRELINK_DISABILITY_PAYMENTS]: 'Centrelink Disability Payments',
  [INCOME_TYPE.CENTRELINK_PENSION]: 'Centrelink Pension',
  [INCOME_TYPE.CENTRELINK_NEWSTART]: 'Centrelink Jobseeker',
  [INCOME_TYPE.VETERAN_AFFAIRS]: 'Veteran Affairs',
  [INCOME_TYPE.CENTRELINK_OTHER]: 'Centrelink Other',
  [INCOME_TYPE.AUSTUDY]: 'Austudy',
  [INCOME_TYPE.OTHER]: 'Other',
  [INCOME_TYPE.ADDITIONAL_JOB]: 'Additional Job',
  [INCOME_TYPE.COMMISSIONS_BONUSES]: 'Commissions and Bonuses',
}

export const incomeTypeMapNZ = {
  [INCOME_TYPE.RENTAL_INCOME]: 'Rental Income',
  [INCOME_TYPE.CHILD_SUPPORT_NZ]: 'Child Support',
  [INCOME_TYPE.INVESTMENT_INCOME]: 'Investment Income (e.g., shares)',
  [INCOME_TYPE.WORK_AND_INCOME_BENEFITS]: 'Work and Income (WINZ)',
  [INCOME_TYPE.STUDYLINK]: 'Studylink',
  [INCOME_TYPE.WORKING_FOR_FAMILIES]: 'Working for Families',
  [INCOME_TYPE.ACC]: 'ACC',
  [INCOME_TYPE.OTHER_IRD_BENEFIT]: 'Other IRD Benefit',
  [INCOME_TYPE.COMMISSIONS_BONUSES]: 'Commissions and Bonuses',
  [INCOME_TYPE.ADDITIONAL_JOB]: 'Additional Job',
  [INCOME_TYPE.OTHER]: 'Other',
}
